import React from 'react';
import { AuthProvider } from 'react-oidc-context';

import casinoConfig from '@dcentralexpedientedigital/config';
import type { IConfig } from '@dcentralexpedientedigital/fe-shared/types/config.interface.ts';
import { ConfigProvider } from '@dcentralexpedientedigital/fe-ui/context/config-context';

import { MainWithAuth } from '../main-with-auth.tsx';
import { userManager } from '../utils/user-manager.ts';

import { AuthEventManager } from './auth-event-manager';

interface AppRootProps {
    readonly onSigninCallback?: () => void;
}

export const AppRoot = ({ onSigninCallback }: AppRootProps) => {
    const authConfig = casinoConfig.authConfig;

    const handleSigninCallback =
        onSigninCallback ||
        (() => {
            // Do nothing by default
        });

    return (
        <React.StrictMode>
            <ConfigProvider config={casinoConfig as IConfig}>
                <AuthProvider
                    {...authConfig}
                    onSigninCallback={handleSigninCallback}
                    userManager={userManager}
                >
                    <AuthEventManager />
                    <MainWithAuth />
                </AuthProvider>
            </ConfigProvider>
        </React.StrictMode>
    );
};
